"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var react_apollo_1 = require("react-apollo");
var graphql_tag_1 = require("graphql-tag");
var react_tracking_1 = require("react-tracking");
var lodash_1 = require("lodash");
var elog = require("../../elog");
var overflowing_row_1 = require("../../components/overflowing_row");
var tiles_1 = require("../../components/tiles");
var tracker_1 = require("../../tracker");
var curated_set_card_1 = require("./curated_set_card");
var COMPONENT_NAME = 'CuratedSetCollection';
var CuratedSetCollection = /** @class */ (function (_super) {
    tslib_1.__extends(CuratedSetCollection, _super);
    function CuratedSetCollection() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CuratedSetCollection.prototype.componentDidMount = function () {
        if (!this.props.data.loading && this.curatedSets().length) {
            this.props.tracking.trackEvent({
                eventType: tracker_1.VIEW,
                ids: this.curatedSets().map(function (set) { return set.id; }),
            });
        }
    };
    CuratedSetCollection.prototype.componentDidUpdate = function (oldProps) {
        if (!this.props.data.loading && this.curatedSets().length && !lodash_1.isEqual(this.props.data, oldProps.data)) {
            this.props.tracking.trackEvent({
                eventType: tracker_1.VIEW,
                ids: this.curatedSets().map(function (set) { return set.id; }),
            });
        }
    };
    CuratedSetCollection.prototype.displayAs = function (style) {
        return this.props.displayAs === style;
    };
    CuratedSetCollection.prototype.curatedSets = function () {
        return lodash_1.get(this.props.data, 'curatedSets', []) || [];
    };
    CuratedSetCollection.prototype.renderTiles = function () {
        var _this = this;
        return this.curatedSets().map(function (curatedSet, idx) {
            var formData = _this.props.curatedSets.find(function (c) { return c.id === curatedSet.id; });
            if (!formData)
                return null;
            return (React.createElement(curated_set_card_1.default, { key: curatedSet.id, curatedSet: curatedSet, position: idx, rootCategorySlug: _this.props.rootCategorySlug, leafCategorySlug: _this.props.leafCategorySlug, inMobileApp: _this.props.inMobileApp, displayAs: _this.props.displayAs, bannerOverride: formData.bannerOverride, squareImage: formData.squareImage, titleOverride: formData.titleOverride }));
        });
    };
    CuratedSetCollection.prototype.render = function () {
        try {
            if (!this.props.data.loading && !this.curatedSets().length) {
                return null;
            }
            return (React.createElement(overflowing_row_1.default, { title: this.props.title, titleHtml: this.props.titleHtml, subtitleHtml: this.props.subtitleHtml, ledeHtml: this.props.ledeHtml, collectionCount: this.curatedSets().length, id: this.props.jumplinkSlug },
                React.createElement(tiles_1.default, { singleRow: !this.props.displayAsGrid, placeholder: React.createElement(curated_set_card_1.default, { displayAs: this.props.displayAs }), loading: this.props.data.loading, expectedCount: this.props.curatedSets.length, grow: this.displayAs(curated_set_card_1.BASIC_TILE) || !this.props.displayAs, largeTiles: !this.displayAs(curated_set_card_1.FEATURE_TILE), twoWide: this.displayAs(curated_set_card_1.FEATURE_TILE) }, this.renderTiles())));
        }
        catch (e) {
            elog.error("RenderError (" + COMPONENT_NAME + ")", {}, e);
            return null;
        }
    };
    CuratedSetCollection = tslib_1.__decorate([
        react_tracking_1.default(function (props) {
            return {
                componentName: COMPONENT_NAME,
                type: tracker_1.CURATED_SET_TYPE,
                context: {
                    title: props.title,
                    layoutSection: props.layoutSection,
                    pagePosition: props.pagePosition,
                    rootCategorySlug: props.rootCategorySlug,
                    leafCategorySlug: props.leafCategorySlug,
                }
            };
        })
    ], CuratedSetCollection);
    return CuratedSetCollection;
}(React.Component));
exports.CuratedSetCollection = CuratedSetCollection;
var connect = react_apollo_1.graphql(graphql_tag_1.default(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n    query Commons_Cms_CuratedSetCollection(\n      $ids: [String]\n    )\n    {\n      curatedSets(input: {\n        ids: $ids\n      }) {\n        id\n        title\n        webLink {\n          href\n        }\n        images(input: {\n          transform: \"banner_wide\",\n          scope: \"full_bleed_image\",\n          type: \"CuratedSet\"\n        }) {\n          source\n        }\n      }\n    }\n  "], ["\n    query Commons_Cms_CuratedSetCollection(\n      $ids: [String]\n    )\n    {\n      curatedSets(input: {\n        ids: $ids\n      }) {\n        id\n        title\n        webLink {\n          href\n        }\n        images(input: {\n          transform: \"banner_wide\",\n          scope: \"full_bleed_image\",\n          type: \"CuratedSet\"\n        }) {\n          source\n        }\n      }\n    }\n  "]))), {
    options: function (ownProps) { return ({
        ssr: ownProps.ssr,
        variables: {
            ids: ownProps.curatedSets.map(function (c) { return c.id; }),
        },
    }); },
});
exports.default = connect(CuratedSetCollection);
var templateObject_1;
//# sourceMappingURL=curated_set_collection.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/cms/components/curated_set_collection.js
// module id = OAUm
// module chunks = 0 2 6 20